import { memo, useMemo } from 'react';
import FarmerInvoice from './FarmerInvoice';
import { withInvoiceList } from './withInvoiceList';

interface FglFarmerInvoiceListProps {
  fglId: string;
}

const EnhancedInvoiceList = withInvoiceList(FarmerInvoice);

const FglFarmerInvoiceList = ({ fglId }: FglFarmerInvoiceListProps) => {
  const params = useMemo(
    () => ({
      'farmerGroupLeaderId.equals': fglId,
      'status.in': 'unpaid,partially_paid,paid,overdue,sent',
    }),
    [fglId],
  );

  return <EnhancedInvoiceList params={params} />;
};

export default memo(FglFarmerInvoiceList);
